import {
  Fee,
} from '@dapi/sdk';
import {
  currency,
  currencyCode,
} from './currency';

/** Payment card fee */
export const paymentCardFee: Fee = {
  value: 6200,
  currencyCode,
  code: 'OB',
  currency,
  nature: 'paymentCard'
};

/** Ticketing fee */
export const ticketingFee: Fee = {
  value: 1492,
  currency,
  currencyCode,
  nature: 'ticketing'
};
